import { IconBolt, IconCalendarTime, IconChartBar } from '@tabler/icons-react/dist/cjs/tabler-icons-react';
import { TextWithEmoji } from '@shared/ui/text-with-emoji/text-with-emoji';
import { getNoun } from '@utils/lib/getNoun';
import s from '../teacher-matching-progress.module.scss';

export const MatchingHeader = ({ profile, isCompleted, levelLabel, startWhenLabel, matchedCount }) => (
	<div className={s.headerCard}>
		<div className={s.headerContent}>
			<h3 className={s.title}>{isCompleted ? <>Мы нашли {matchedCount} {getNoun(matchedCount, 'идеального преподавателя', 'идеальных преподавателя', 'идеальных преподавателей')}<br/>для вас</> : <>Подбираем преподавателя<br/>именно для вас</>}</h3>
			<p className={s.subtitle}>{isCompleted ? "Мы тщательно подобрали преподавателей, которые лучше всего подходят под ваши цели и предпочтения." : "Мы анализируем ваши цели и опыт, чтобы найти идеального преподавателя."}</p>
			<div className={s.tags}>
				{profile?.instruments?.length > 0 ? (
					<span className={s.tag}>
						<IconBolt className={s.icon}/> 
						<span className={s.label}>Инструменты:{' '}</span>
						<span className={s.accent}>
							{profile.instruments.map((instrument, index) => (
								<span key={instrument?.id || instrument?.name}>
									{index > 0 ? ', ' : ''}
									<TextWithEmoji text={instrument?.name} className={s.emoji}/>
								</span>
							))}
						</span>
					</span>
				) : null}
				{levelLabel ? (
					<span className={s.tag}>
						<IconChartBar className={s.icon}/> <span className={s.label}>Уровень:</span> <span className={s.accent}>{levelLabel}</span>
					</span>
				) : null}
				{startWhenLabel ? (
					<span className={s.tag}>
						<IconCalendarTime className={s.icon}/> <span className={s.label}>Занятия:</span> <span className={s.accent}>{startWhenLabel}</span>
					</span>
				) : null}
			</div>
		</div>
		<div className={s.headerImageWrapper}>
			<img className={s.headerImage} src={process.env.REACT_APP_STORAGE_URL + (isCompleted ? 'images/mascot/man-guitar.webp' : 'images/mascot/man-search.webp')} alt="" />
		</div>
	</div>
);
